module.exports = __webpack_public_path__ + "img/home-bg.9c3f72f8.jpg";